//
// xross.club App commmon REPORT Definition
//
// xross.club report defines
// ver 1.0.0

export const CATEGORY_TITLE_MAP = Object.fromEntries(
  [
    {
      title: '不快または気に入らない投稿',
      description:
        '投稿内容が個人的に不快である、あるいは好ましくないと感じた場合。',
      value: 'offensive',
    },
    {
      title: 'いじめや望まない接触',
      description:
        '嫌がらせ、ハラスメント、ストーカー行為など、不快なコミュニケーションが含まれる場合。',
      value: 'harassment',
    },
    {
      title: '自傷行為や精神的な問題に関する投稿',
      description:
        '自殺、自傷行為、摂食障害など、深刻な精神的健康問題に関連する内容を含む場合。',
      value: 'self_harm',
    },
    {
      title: '暴力的、差別的、または搾取的な内容',
      description:
        '暴力の描写、ヘイトスピーチ、人種・性別などに対する差別的発言、または搾取的行為の疑いがある場合。',
      value: 'violence',
    },
    {
      title: '禁止・制限されている商品の販売や宣伝',
      description:
        '違法薬物、武器、アルコール、タバコなど、プラットフォーム上で販売が禁止または制限されている商品の宣伝や販売を行っている場合。',
      value: 'prohibited_sales',
    },
    {
      title: 'ヌード画像または性的な内容',
      description:
        '過度に露出のある画像や動画、性的行為を示唆または描写する内容を含む場合。',
      value: 'nudity',
    },
    {
      title: '詐欺的行為またはスパム投稿',
      description:
        '詐欺の可能性がある勧誘、迷惑な大量投稿、無関係なリンクの拡散などが行われている場合。',
      value: 'fraud',
    },
    {
      title: '虚偽または誤解を招く情報の拡散',
      description:
        '事実に基づかない情報や、人々を誤解させる可能性のあるコンテンツを含む場合。',
      value: 'misinformation',
    },
  ].map((item) => [item.value, item.title])
);
